var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.ready)?_c('base-monitor',{attrs:{"data":_vm.data,"idKey":_vm.idKey,"constants":_vm.constants}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }